import React,{useState,useEffect} from "react";
import {doc,setDoc} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { toast } from "react-toastify";
import { useAuthUser } from "../context/authuser";
import { XMarkIcon,PencilSquareIcon, UserCircleIcon } from "@heroicons/react/24/outline";


function ProfileInfo({user}){
    const [edit, setEdit] = useState(false)
    const [update,setUpdate] = useState(false)
    const [showName, setShowName] = useState({})
    const {dbUser,liveUser,upload} = useAuthUser()
    const [uploading,setUploading] = useState(false)
    const[photo,setPhoto] = useState(null)


    const [storeEdit, setStoreEdit] = useState({
        name: "",
        about: "",
        gender: "",
    })

    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        const name = dbUser.filter((item) => {
            if (liveUser?.uid === item?.uid) {
                return item
            }
        })
        setShowName(...name)
    }, [dbUser, liveUser, liveUser?.uid])
    
    function handlePic(){
        upload(photo,liveUser,setUploading)
       }

    const onEdit = (urname,urabout,urgender) => {
        setEdit(true)
        setStoreEdit((prev) => ({
            ...prev,
            name: urname,
            about: urabout,
            gender: urgender,

        }))
    }

    async function updateData(){
        setUpdate(true)
        await setDoc(doc(db,"users", showName?.id),{
            name: storeEdit.name,
            about:storeEdit.about,
            gender: storeEdit.gender
         },{merge:true}).then(() => {
           toast.success("update successfully")
        })
        setUpdate(false)
    }
    const editChange = (e) => {
        const { name, value } = e.target
        setStoreEdit((prev) => ({
            ...prev,
            [name]: value
        }))
    }
    const handleOnchage = (e) => {
        if(e.target.files[0]){
            setPhoto(e.target.files[0])
        }
    } 
 return(
        <div>
            <div className="">
                            <h4 className="info">Profile Info</h4>
                            {  showName ? (
                                <>
                                    <div className="profile-view">
                                    {showName?.photoURL ? 
                                    <img className="view-img"  src={showName?.photoURL} alt="logo"></img>
                                       : <UserCircleIcon className="view-img"/>
                                    } 
                                        <h4>{showName.name}</h4>
                                        <p>{showName.about}</p>

                                    </div>
                                    <div className="personal">
                                        <>
                                            <div className="edit">
                                                <h2>Personal Information</h2>
                                                {edit ?
                                                    <XMarkIcon onClick={() => setEdit(false)} className="edit-icon" /> : <PencilSquareIcon onClick={() => onEdit(showName?.name, showName?.about, showName?.gender)} className="edit-icon" />

                                                }
                                            </div>
                                            {edit ? (<>
                                                <strong className="per">Name : </strong><br />
                                                <input type="text"
                                                    className="input-text"
                                                    placeholder="edit name"
                                                    name="name"
                                                    value={storeEdit?.name}
                                                    onChange={editChange}
                                                /><br />
                                                <span className="per">About: </span><br />
                                                <textarea type="text"
                                                    placeholder="Set bio"
                                                    name="about"
                                                    value={storeEdit?.about}
                                                    onChange={editChange}
                                                /><br />
                                                <span className="per">Gender : </span><br />
                                                <input type="text"
                                                    className="input-text"
                                                    placeholder="Set gender"
                                                    name="gender"
                                                    value={storeEdit?.gender}
                                                    onChange={editChange}
                                                /><br />
                                                
                                                <button onClick={() =>updateData()} className="img-upload">{update ? "updating..." : "update"}</button>
                                            </>) : (<>
                                              
                                                <p className="per-info"><strong>Name : </strong>{showName?.name}</p>
                                                <p className="per-info"> <strong>E-mail :</strong> {showName.email ? showName?.email : ""}</p>
                                                <p className="per-info"><strong>About : </strong> {showName.about ? showName?.about : "Enter bio"}</p>
                                                <p className="per-info"><strong>Gender :</strong> {showName.gender ? showName?.gender : "Enter age"}</p>
                                                <strong>Set your profile image</strong>
                                                <input className="upload" onChange={handleOnchage} type="file"/><br/>
                                                <button  className="img-upload" onClick={handlePic}>{uploading ? "uploading...." : "upload"}</button>
                                            </>)}

                                        </>
                                    </div>
                                </>
                            ) : (
                               <></>
                            )
                            }
                        </div>
        </div>
    )
}

export default ProfileInfo;